import React, { useEffect } from "react";
import styles from "./DevelopmentFinanceBlogs.module.scss";
import Footer from "../../components/Footer";
import CompareContainer6 from "../../components/CompareContainer/CompareContainer6";
import TypeOfRequirements from "../../components/TypeOfRequirements";
import MatchingMortgages6 from "../../components/MatchingMortgages/MatchingMortgages6";
import NewsContainer from "../../components/NewsContainer";
import LoanApplication6 from "../../components/LoanApplication/LoanApplication6";
import HeroSection from "../../components/HeroSection/HeroSection";
import TestimonialsContainer from "../../components/TestimonialsContainer";
const DevelopmentFinanceBlogs6 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.developmentFinanceBlogs}>
      <HeroSection title="Development Finance" />
      <CompareContainer6 title="Development Finance" />
      <TypeOfRequirements title="Development Finance" />
      <MatchingMortgages6 title="Development Finance" />
      <NewsContainer title="Development Finance" />
      <LoanApplication6 title="Development Finance" />
      <TestimonialsContainer title="Development Finance" />
      <Footer title="Development Finance" />
    </div>
  );
};

export default DevelopmentFinanceBlogs6;
